export const TOP_POSITION_COUNT = 10
export const TOP_COMPOSITION_FACTORS = 10

// Fallback when theme is not available (e.g. selectors, tests). Prefer useThemeChartColors() in React.
export const COLORS = [
  "#da7c30",
  "#396ab1",
  "#3e9651",
  "#cc2529",
  "#535154",
  "#6b4c9a",
  "#922428",
  "#948b3d",
  "#9b3d70",
  "#237994",
  "#FFCF0D",
  "#19FFE7",
  "#E51BF5",
  "#74F50F",
  "#015175",
]

// theme.palette is frozen to the light scheme, so dark mode needs its own value for a color that is unreadable there.
// #535154 is near-black on dark and reads as the unplotted grey, so it flips to an off-white.
// Only applied via useThemeChartColors(); direct COLORS importers (selectors, templates) intentionally stay on the original.
export const DARK_MODE_SERIES_OVERRIDES = { "#535154": "#e6e6e6" }

export const ANALYZE_FACTORS_TAKE = COLORS.length

export const BETA_CATEGORIES = [{
  id: "beta",
  label: "Beta",
  color: COLORS[0],
}]

export const BETA_FACTORS = {
  historical: {
    category: "beta",
    label: "Historical",
  },
  predicted: {
    category: "beta",
    label: "Predicted",
  },
}

export const BETA_FACTORS_WITH_DYNAMIC = {
  ...BETA_FACTORS,
  dynamicPredicted: {
    category: "beta",
    label: "Custom",
  },
}

export const CONCENTRATION_FACTORS = {
  positionsCount: {
    category: "concentration",
    label: "Num. Positions",
    color: "#00abe8",
  },
  maxConcentration: {
    category: "concentration",
    label: "Max Concentration",
    area: "rgba(144, 103, 167, 0.1)",
    percentage: true,
    color: "#9067a7",
  },
  topConcentration: {
    category: "concentration",
    label: `Top ${TOP_POSITION_COUNT} Positions`,
    area: "rgba(97, 122, 140, 0.2)",
    percentage: true,
    color: "#cccccc",
  },
}

export const CATEGORIES = [
  ...BETA_CATEGORIES,
  {
    id: "concentration",
    label: "Concentration",
    color: COLORS[1],
  },
]

export const MANDATORY_PERFORMANCE_METRICS = { total: true, factor: true, alpha: true }

export const FACTORS_THRESHOLD = 0.0001

// Fallback when theme is not available. Prefer useThemeChartColors() in React for theme-aware colors.
export const ATTRIBUTION_COLORS = {
  TOTAL: "#00abe8",
  FACTOR: "#9067a7",
  ALPHA: "#627b8c",
  TRADING: "#da7c30",
  RISK_FREE: "#2e8b57",
  SEGMENT: "#009688",
}

export const ATTRIBUTION_AREAS = {
  FACTOR: "rgba(144, 103, 167, 0.1)",
  ALPHA: "rgba(97, 122, 140, 0.2)",
  TRANSPARENT: "rgba(0, 0, 0, 0)",
}

// Performance attribution overall items - shared across performance analysis views
export const PERFORMANCE_OVERALL_ITEMS = [{
  id: "total",
  color: ATTRIBUTION_COLORS.TOTAL,
  label: "Total",
  field: "total",
  type: "overall",
}, {
  id: "factor",
  color: ATTRIBUTION_COLORS.FACTOR,
  label: "Factor",
  field: "factorsTotal",
  type: "overall",
}, {
  id: "alpha",
  color: ATTRIBUTION_COLORS.ALPHA,
  label: "Alpha",
  field: "alpha",
  type: "overall",
}, {
  id: "tradingPnl",
  color: ATTRIBUTION_COLORS.TRADING,
  label: "Trading",
  field: "trading",
  type: "overall",
}]
